// ============================================
// styles/theme.js
// ============================================
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFD700', // Gold
      light: '#FFF5D7',
      dark: '#FFC300',
      contrastText: '#000000',
    },
    secondary: {
      main: '#3E3E3E', // Dark gray
      light: '#666666',
      dark: '#222222',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#0F172A',
      paper: '#111827',
    },
    text: {
      primary: '#E5E7EB',
      secondary: '#9CA3AF',
    },
    error: {
      main: '#f44336',
    },
    success: {
      main: '#4caf50',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    // Ensure styled variants don't render as headings unless explicitly requested
    // This prevents axe heading-order violations from, e.g., subtitle1 mapping to <h6>
    variantMapping: {
      h6: 'p',
      subtitle1: 'p',
      subtitle2: 'p',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h6: 'p',
          subtitle1: 'p',
          subtitle2: 'p',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 14,
        },
      },
      variants: [
        {
          props: { variant: 'glass' },
          style: {
            backgroundColor: 'rgba(15,23,42,0.18)',
            backdropFilter: 'blur(12px) saturate(140%)',
            WebkitBackdropFilter: 'blur(12px) saturate(140%)',
            border: '1px solid rgba(255,255,255,0.12)',
          },
        },
      ],
    },
    MuiTextField: {
      defaultProps: {
        variant: 'filled',
        fullWidth: true,
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
          },
        },
      },
    },
    MuiLink: {
      defaultProps: {
        color: 'inherit',
        underline: 'always',
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: 'rgba(255,255,255,0.06)',
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.09)',
          },
          '&.Mui-focused': {
            backgroundColor: 'rgba(255,255,255,0.06)',
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme;

